<template>
  <div
    class="filter-pills text-noselect"
    :style="`transition:0.22s; ${
      localVisible
        ? 'height:1.65rem;margin-top:var(--active-margin-top);margin-bottom:var(--active-margin-bottom)'
        : 'height:0px; margin-top:0px;margin-bottom:0px;'
    }`"
  >
    <div
      class="filter-pills_inner-wrapper scroll-left-overlay scroll-right-overlay"
      style="--clr-scrl-back: var(--clr-pills-back); --scrl-width: 0.875rem"
    >
      <div
        ref="hscrl_inner"
        class="filter-pills_inner no-scroll-track"
        @wheel.stop="e => wheelScroll(e)"
        @mousedown.stop="e => hscrl_dragScrollMousedown(e)"
      >
        <!-- turn -->
        <div
          v-for="(values, key) in reports_flop_filter"
          :key="key"
          class="d-flex"
        >
          <div class="text-nowrap weight_500 text-small clr-grey ml-2 mr-1 my-auto">
            {{
              $te(`practice.filter.${key}_abbr`)
                ? $t(`practice.filter.${key}_abbr`)
                : $t(`practice.filter.${key}`)
            }}:
          </div>
          <div
            v-if="typeof values === 'string'"
            class="gw_btn-r1 filter-pills_pill"
            @click="rmFlopFilterItem(key, 0)"
          >
            {{ values }}
            <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
          </div>
          <div
            v-for="(value, idx) in values"
            v-else
            :key="value + key"
            class="gw_btn-r1 filter-pills_pill"
            @click="rmFlopFilterItem(key, idx)"
          >
            {{
              key.includes('card') || key.includes('subset')
                ? value
                : $t(`practice.filter.${value}`)
            }}
            <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
          </div>
        </div>

        <div
          v-if="turn_filter_hand.length"
          class="gw_btn-r1 filter-pills_pill"
          @click="clearTurnFilterHand"
        >
          <PokerCard
            v-for="(item, idx) in turn_filter_hand"
            :key="idx"
            :card="item"
            size="mini"
          />
          <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
        </div>

        <!-- shared -->
        <div
          v-for="(item, idx) in study_filter_actions"
          :key="idx + 'ac'"
          class="gw_btn-r1 filter-pills_pill"
          @click="removeAction(item)"
        >
          <span v-html="getBetHtml({ showBetsIn, name: true, a: item })"></span>
          <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
        </div>

        <!-- flop -->
        <div
          v-for="item in [
            study_suits.suited.length ? { id: 'suited', text: 'suited' } : null,
            study_suits.offsuited.length ? { id: 'offsuited', text: 'offsuited' } : null,
            study_suits.exclude_suited.length
              ? { id: 'exclude_suited', text: 'exclude_suited' }
              : null,
            study_suits.exclude_offsuited.length
              ? { id: 'exclude_offsuited', text: 'exclude_offsuited' }
              : null,
          ].filter(i => i)"
          :key="item.id"
          class="d-flex"
        >
          <div class="text-nowrap weight_500 text-small clr-grey ml-2 mr-1 my-auto">
            {{ $t(`common.${item.text}`) }}
          </div>
          <div
            class="gw_btn-r1 filter-pills_pill"
            @click="removeSuit(item.id)"
          >
            <div
              v-for="symbol in study_suits[item.id]"
              :key="symbol"
              class="mdi text-large"
              :style="`color: var(${cards[symbol].color})`"
              :class="`${cards[symbol].icon}${item.text.includes('exclude') ? '-outline' : ''} ${
                !item.id.includes('off') ? 'suitsfiltr_suited' : ''
              }`"
            ></div>
            <i class="mdi icon_btn pa-1 mdi-close text-normal"></i>
          </div>
        </div>

        <div
          v-for="(item, idx) in study_filter_categories"
          :key="idx + 'r'"
          class="gw_btn-r1 filter-pills_pill"
          @click="removeCategory(item)"
        >
          {{ $t(`browse.filter_rules.${item.name}`) }}
          <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
        </div>
      </div>
    </div>
    <div
      v-if="filterActive && hasFilterIntersection"
      class="f-center"
      style="
        padding: 0 0.25rem;
        background: var(--clr-black-2);
        border-radius: 6px;
        height: 1.65rem;
        margin: 0px 0.25rem 0 1px;
      "
    >
      <!-- style="padding: 0 0.25rem; background: var(--clr-black-1); border-radius: 6px; height: 2em" -->
      <UnSwitcherNew
        swKey="sw_study_filter_intersection"
        :tstPrefix="tstPrefix"
        @click="$store.dispatch(SNK('sol_filters_handle_mode_change', namespace))"
      />
    </div>
    <div
      v-if="filterActive && hasClearBtn"
      class="clear-all-btn gw_btn_uppercase weight_500 gw_btn filter-pills_pill text-small csst csst_nm z-index_4"
      style="--clr-back: var(--clr-error)"
      data-tst="reset_filters_btn"
      @click="clearAll"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
    >
      {{ $t('btn.clear') }}

      <div
        class="csst_content"
        style="position: fixed"
        v-html="
          $t('hotkeys.study_reset_filters_key', {
            key: hotkeys.study_reset_filters.displayCombination,
          })
        "
      ></div>
    </div>
  </div>
</template>

<script>
import { getFilterBase } from '@/store/tableFilters/tableFilters'
import { getLocalFiltersConfigs } from '@/components/DataTables/Filters/new/filter_helpers'

import PokerCard from '@/components/Poker/PokerCard/PokerCard'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import { SNK } from '@/helpers/helpers'
import { getCardsFromStr } from '@/helpers/cards'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'StudyFiltersPills',
  components: {
    PokerCard,
    UnSwitcherNew,
  },
  mixins: [horizontalScroll_mix, format_mix, float_mix],
  props: {
    namespace: String,
    visible: { type: Boolean, default: true },
    hasClearBtn: { type: Boolean, default: true },
    hasFilterIntersection: { type: Boolean, default: false },
    alwaysVisible: Boolean,
    street: String,
    showBetsIn: String,
    filterCombos: Object,
    soltab: String, // strategy, reports
    tstPrefix: { default: 'filterpills' },
  },
  emits: ['click:clear'],
  data() {
    this.cards = {
      s: { color: '--clr-spades', icon: `mdi-cards-spade` },
      h: { color: '--clr-hearts', icon: `mdi-cards-heart` },
      d: { color: '--clr-diamonds', icon: `mdi-cards-diamond` },
      c: { color: '--clr-clubs', icon: `mdi-cards-club` },
    }
    return {}
  },
  methods: {
    clearAll() {
      if (!this.filterActive) return
      this.$emit('click:clear')
      // this.sol.study_filter_eq_buckes = []
      this.$store.commit(SNK('sol_filters_set', this.namespace), { key: 'actions', value: [] })
      // console.log('clearAll', this.soltab)
      if (this.soltab !== 'reports') {
        this.$store.commit(SNK('sol_filters_set', this.namespace), {
          key: 'suits',
          value: {
            suited: [],
            offsuited: [],
            exclude_suited: [],
            exclude_offsuited: [],
          },
        })
        this.$store.commit(SNK('sol_filters_set', this.namespace), { key: 'categories', value: [] })
        this.$store.dispatch('globals_action', 'reset_graph_zoom')
        this.$store.dispatch(SNK('sol_data_applyFilter', this.namespace))
      } else {
        this.clearTurnFilterHand()
        this.clearReportsFlopFilter()
      }
    },

    clearTurnFilterHand() {
      this.$store.commit('reports_set', { key: 'turn_filterHand', value: '' })
    },
    clearReportsFlopFilter() {
      this.$store.commit('filters_set', {
        key: 'ffrf',
        value: getFilterBase(),
      })
    },
    removeSuit(id) {
      const value = { ...this.study_suits, [id]: [] }
      this.$store.dispatch(SNK('sol_filters_apply', this.namespace), { key: 'suits', value })
    },
    removeAction(action) {
      const value = this.filterCombos.actions.filter(c => c.code !== action.code)
      this.$store.dispatch(SNK('sol_filters_apply', this.namespace), { key: 'actions', value })
    },
    removeCategory(category) {
      const value = this.filterCombos.categories.filter(c => c.name !== category.name)
      this.$store.dispatch(SNK('sol_filters_apply', this.namespace), { key: 'categories', value })
    },
    rmFlopFilterItem(key, idx) {
      // TODO new Filters
      // this is also kinda hacky - lets make this external removing of parameters part of the new class
      const raw = this.$store.getters.ffrf.params || {}
      const filter = { ...raw }

      const current = filter[key]

      if (Array.isArray(current)) {
        current[idx] = null
        filter[key] = current.filter(i => i)
        if (!filter[key].length) {
          delete filter[key]
        }
      } else {
        delete filter[key]
      }

      const filterConfig = getLocalFiltersConfigs()[this.filterConfigKey]
      const filterConf = {
        loaded: true,
        data: filterConfig,
        params: filter,
        filter,
        active: Object.keys(filter).length,
      }

      this.$store.commit('filters_set', {
        key: 'ffrf',
        value: filterConf,
      })
    },
  },
  computed: {
    localVisible() {
      if (this.alwaysVisible) return true
      return this.visible && this.filterActive
    },
    reports_flop_filter() {
      if (this.soltab === 'reports' && this.street === 'flop') {
        const res = this.$store.getters.ffrf.params || {}
        return res
      }
      return {}
    },
    turn_filter_hand() {
      if (this.soltab === 'reports' && this.street === 'turn') {
        const hand = this.$store.getters.rep_turn_filterHand
        if (!hand) return []
        const res = getCardsFromStr(hand)
        return res
      }
      return []
    },
    study_filter_actions() {
      return this.filterCombos.actions
    },
    study_filter_categories() {
      if (this.$route.name === 'StudySolutions' && this.soltab === 'reports') {
        return []
      }
      return this.filterCombos.categories
    },
    study_suits() {
      if (this.$route.name === 'StudySolutions' && this.soltab === 'reports') {
        return {
          suited: [],
          offsuited: [],
          exclude_suited: [],
          exclude_offsuited: [],
        }
      }
      return this.filterCombos.suits
    },
    filterActive() {
      if (this.$route.name === 'StudySolutions') {
        if (this.soltab === 'reports') {
          return (
            this.study_filter_actions.length ||
            this.turn_filter_hand.length ||
            Object.keys(this.reports_flop_filter).length
          )
        }
      }
      return this.filterCombos.status !== 'inactive'
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
  },
  watch: {
    hotkeysPressed(keys) {
      if (!keys) return
      const hotkeyActions = {
        reset_history: {
          keys: this.hotkeys.study_reset_filters.keyCombination,
          fn: () => this.clearAll(),
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>

<style lang="scss" scoped>
.suitsfiltr_suited {
  text-shadow:
    0.6px 0px 2px var(--clr-black-0),
    4px 0px 0px currentColor;
}
@media (max-width: 1023px) {
  .filter-pills {
    &:after {
      content: '';
      background: linear-gradient(to left, var(--clr-black-0), transparent) !important;
      width: 4px !important;
    }
    &_inner {
      width: 100% !important;
    }
  }
}
.clear-all-btn {
  // position: sticky;
  // right: 0;
  z-index: 2;
  // background: var(--clr-black-1);
}
.filter-pills-no-stretch {
  .filter-pills_inner {
    width: auto !important;
  }
}
.filter-pills-no-scroll {
  .filter-pills_inner {
    width: auto !important;
    position: relative !important;
  }
}
.filter-pills {
  //  margin-top:var(--active-margin-top);
  display: flex;
  position: relative;
  align-items: center;
  overflow: hidden;
  min-width: 0;
  --clr-pills-back: var(--clr-black-0);
  &_inner-wrapper {
    position: relative;
    display: flex;
    min-width: 0;
    margin: 0 0 0 auto;
    // margin: 0 2px 0 auto;
    z-index: 1;
  }
  &_inner {
    overflow-x: auto;
    position: relative;
    min-width: 0;
    // width: 100%;
    // max-width: 100%;
    display: flex;
    // grid-gap: 2px;
    // height: 100%;
    padding: 0 0.5rem;
  }
  &_pill {
    font-size: 0.8rem;
    white-space: nowrap;
    // height: 100%;
  }
  .pill-symbol {
    padding: 0;
    height: 1.125rem;
    width: 1.125rem;
    fill: currentColor;
  }
}
</style>
